module.exports = __webpack_public_path__ + "media/images/flags/1x1/uga-543d3543981b0c40fdd291d0c061ae8b.svg";